var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUzcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.01 29.52c0 8.708-1.99 15.198-5.968 19.427-3.979 4.228-10.126 6.342-18.413 6.342-7.743 0-13.617-2.114-17.622-6.342C2 44.719-.001 38.342-.001 29.817V1.215A1.218 1.218 0 011.214 0h14.04a1.22 1.22 0 011.215 1.215v29.227c0 3.481.644 6.16 1.955 8.05a7.095 7.095 0 008.687 2.147 7.096 7.096 0 002.513-1.979c1.282-1.773 1.92-4.386 1.916-7.84v-5.473h16.47v4.173z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.738 22.15H31.542V1.273A1.276 1.276 0 0132.815 0h2.275a12.911 12.911 0 003.787 9.125 12.922 12.922 0 009.131 3.78h.004v9.245h-1.274z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.326 0h8.413a1.277 1.277 0 011.273 1.273v8.42A9.688 9.688 0 0138.326.01V0z",
    fill: "#F4821F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.757 69.18c1.859 0 2.756-1.034 2.756-2.553v-3.661h-1.33v3.624a1.432 1.432 0 01-2.866 0v-3.624H-.002v3.672c0 1.5.897 2.544 2.756 2.544l.003-.002zm10.784-.11v-1.143h-2.948l2.885-3.92v-1.044H8.89v1.144h2.885L8.89 68.016v1.05l4.651.004zm6.215.11a2.815 2.815 0 002.554-1.501l-1.12-.54a1.638 1.638 0 01-1.438.888 2.008 2.008 0 01-1.355-3.388c.355-.373.84-.596 1.355-.621a1.656 1.656 0 011.438.887l1.12-.55a2.795 2.795 0 00-2.554-1.49 3.161 3.161 0 00-3.005 4.387 3.158 3.158 0 003.005 1.928zm11.36-.11l-2.353-6.104h-1.63L24.77 69.07h1.484l.384-1.034h2.62l.375 1.034h1.483zM28.9 66.892h-1.905l.953-2.627.952 2.627zm10.994 3.71l-2.24-3.855a1.75 1.75 0 001.336-1.812 1.901 1.901 0 00-2.05-1.968h-2.86v6.105h1.3v-2.17h.953l2.067 3.699 1.493.001zm-3.147-4.843h-1.364v-1.647h1.36a.829.829 0 110 1.647h.004zm8.027 3.313c1.914 0 3.242-1.208 3.242-3.048s-1.331-3.057-3.242-3.057h-2.408v6.105h2.408zm0-1.144h-1.108v-3.816h1.108a1.788 1.788 0 011.914 1.912 1.825 1.825 0 01-1.918 1.903l.004.001zm4.821-5.078v.016a1.136 1.136 0 11-1.137-1.136h1.136v1.12z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v70H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzcard);
export default __webpack_public_path__ + "static/media/uzcard.e3841b6ea58258ffbc9eb965a0c5d3f8.svg";
export { ForwardRef as ReactComponent };